import {useParams} from 'react-router-dom';
import {FormatDateTime} from "@haravan/react-components";
import {PartnerRepository} from "../../../../repositories";
import {Currency, Detail, Link, Status} from "../../../../components";
import {ListViewHeader, ListViewPageSize, ListViewPagingInfo, ListViewSimplePaging} from "../../../../components";
import {STATUS_APP_NAME} from '../../../../components/status/status'

import "./index.css";

const getData = (paging: ListViewPagingInfo, id) => PartnerRepository.GetAppByPartnerId(id, paging.searchText, paging.before, paging.after, paging.limit);

const headers = [
    {name: "Tên ứng dụng", className: "partner-app-name"},
    {name: "Đối tác", className: "partner-app-partner-name"},
    {name: "Giá bán", className: "partner-app-price-cost"},
    {name: "Hạn dùng thử", className: "partner-app-trial-days"},
    {name: "Ngày đăng ký", className: "partner-app-created-date"},
    {name: "Trạng thái", className: "partner-app-status"},
] as ListViewHeader[];

export const PartnerApp = (props) => {
    const {partnerId} = useParams();

    const renderRow = (app, index) => {
        let prices = app?.prices?.filter((p) => p.status == STATUS_APP_NAME.Approved).map((p) => p.priceApprove);
        let min = prices?.length ? Math.min(...prices) : 0;
        let max = prices?.length ? Math.max(...prices) : 0;
        if (app != null) {
            return (
                <tr className="data-list-row">
                    <td className="data-list-cell object">
                        <Detail to={`./${app?.id}`}>{`${app?.name}`}</Detail>
                    </td>
                    <td className="data-list-cell object">
                        <Detail
                            to={`/partners/${app?.partner?.id}`}>{`${app?.partner?.lastName} ${app?.partner?.firstName}`}</Detail>
                    </td>
                    <td className="data-list-cell object">
                        {prices?.length > 1 ? (
                            <div className={"d-flex"}>
                                <Currency ammount={min} width={"auto"}/>
                                <div className='partner-app-price-mid'>-</div>
                                <Currency ammount={max} width={"auto"}/>
                            </div>
                        ) : (
                            <Currency ammount={min} width={"auto"}/>
                        )}
                    </td>
                    <td className="data-list-cell object">
                        <p>{app?.trialDay}</p>
                    </td>
                    <td className="data-list-cell object">{FormatDateTime(app.createdAt)}</td>
                    <td className="data-list-cell object">
                        <Status text={app.status}/>
                    </td>
                </tr>
            );
        }
    };

    return (
            <div className="row">
                <ListViewSimplePaging
                    allowSearch
                    searchPlaceHolder="Tìm kiếm theo id, tên"
                    className="theme-file-border"
                    getData={(paging) => getData(paging, partnerId)}
                    pageSize={ListViewPageSize.SMALL_PAGE_SIZE}
                    renderRow={renderRow}
                    headers={headers}
                    version={2}
                />
            </div>
    );
};
